export const DropdownPlacements = {
  TOP: 'top',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  BOTTOM: 'bottom',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end',
  RIGHT: 'right',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
  LEFT: 'left',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end',
  AUTO: 'auto',
  AUTO_START: 'auto-start',
  AUTO_END: 'auto-end',
};

export const DropdownTriggers = {
  CLICK: 'click',
  HOVER: 'hover',
  RIGHT_CLICK: 'right-click',
};

export const EventTypes = {
  CLICK: 'click',
  RIGHT_CLICK: 'contextmenu',
};

export const hoverShowEvents = ['mouseenter', 'focus'];

export const hoverHideEvents = ['mouseleave', 'blur'];

export const DEFAULT_OFFSET = [0, 8];

export const TransitionDuration = 200;

export const PopperMinWidth = 200;

export const X_OFFSET = 8;

export const Y_OFFSET = 8;
